import styled from 'styled-components';

export const QaArchivePageConteiner = styled.div`
  padding-top: 65px;
`;

export const MainQaArchiveConteiner = styled.div`
  display: flex;
`;
